import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditUserData } from "./adminComp/userEditModal";
import "./AdminDashboard.css";

function Users({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [selectedData, setSelectedData] = useState({});

  const [showEdit, setShowEdit] = useState(false);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [subscribeReason, setSubscribeReason] = useState("");
  const [selectedUserForSubscribe, setSelectedUserForSubscribe] = useState(null);
  const handleCloseEdit = () => setShowEdit(false);
  const handleCloseSubscribeModal = () => {
    setShowSubscribeModal(false);
    setSubscribeReason("");
    setSelectedUserForSubscribe(null);
  };
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };
  const handleShowSubscribeModal = (item) => {
    setSelectedUserForSubscribe(item);
    setSubscribeReason("");
    setShowSubscribeModal(true);
  };

  const getUsers = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const userData = await api.allUsers(payload);
      setData(userData.user);
      setnoOfUser(userData.count);
      setLimit(userData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const deleteUser = async (id) => {
    try {
      let payload = {
        id: id,
      };
      setLoader(true);
      const userData = await api.deleteUser(payload);
      console.log("deleted");
      getUsers();
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        email: searchMail,
      };
      const res = await api.getUserByMail(payload);
      if (res?.success) {
        setData(res?.user);
        setLimit(res?.user?.length || 10);
        setnoOfUser(res?.user?.length || 0);
      } else {
        alert("Invalid Email Address");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  useEffect(() => {
    getUsers();
  }, [page, resetPage]);

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
  };

  const makeSubscribeUser = async () => {
    if (!subscribeReason.trim()) {
      alert("Reason is required");
      return;
    }

    if (!selectedUserForSubscribe?.email) {
      alert("User email not found");
      return;
    }

    try {
      let payload = {
        email: selectedUserForSubscribe.email,
        reason: subscribeReason.trim(),
      };
      setLoader(true);
      const userData = await api.SuperAdminMakePaidUser(payload);
      console.log("User subscribed");
      if (userData?.success) {
        alert(userData?.msg);
        handleCloseSubscribeModal();
        getUsers();
      } else {
        alert(userData?.msg || "something went wrong");
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };
  const grantGodzillaAccess = async (id) => {
    try {
      let payload = {
        targetUserId: id,
      };
      setLoader(true);
      const userData = await api.grantGodzillaAccess(payload);
      console.log("User subscribed");
      if (userData?.success) {
        alert(userData?.message);
        getUsers();
      } else {
        alert(userData?.message || "something went wrong");
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      alert("something went wrong");
      setLoader(false);
    }
  };
  const removeGodzillaAccess = async (id) => {
    try {
      let payload = {
        targetUserId: id,
      };
      setLoader(true);
      const userData = await api.removeGodzillaAccess(payload);
      console.log("Access Removed");
      if (userData?.success) {
        alert(userData?.message);
        getUsers();
      } else {
        alert(userData?.message || "something went wrong");
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      alert("something went wrong");
      setLoader(false);
    }
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid payHistoryPage">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="users-management-wrapper">
              {/* Header Section */}
              <div className="users-header-section">
                <div className="users-header-content">
                  <div className="users-title-section">
                    <h1 className="users-main-title">
                      <i className="fas fa-users me-3 users-title-icon"></i>
                      User Management
                    </h1>
                    <p className="users-subtitle">
                      Manage and monitor all registered users in the system
                    </p>
                  </div>

                  {/* Enhanced Search Section */}
                  <div className="users-search-section">
                    <div className="users-search-container">
                      <div className="users-search-input-wrapper">
                        <i className="fas fa-search users-search-icon"></i>
                        <input
                          type="text"
                          className="users-search-input"
                          placeholder="Search users by email address..."
                          value={searchMail}
                          onChange={(e) => setSearchMail(e.target.value)}
                          onKeyPress={(e) =>
                            e.key === "Enter" && handleSearch()
                          }
                        />
                        {searchMail && (
                          <button
                            className="users-search-clear"
                            onClick={() => setSearchMail("")}
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        )}
                      </div>
                      <button
                        className="users-search-btn"
                        onClick={handleSearch}
                      >
                        <i className="fas fa-magnifying-glass me-2"></i>
                        Search
                      </button>
                    </div>
                    <button className="users-reset-btn" onClick={handleReset}>
                      <i className="fas fa-arrows-rotate me-2"></i>
                      Reset
                    </button>
                  </div>
                </div>

                {/* Stats Cards */}
                <div className="users-stats-container">
                  <div className="users-stat-card">
                    <div className="users-stat-icon total-users">
                      <i className="fas fa-user-friends"></i>
                    </div>
                    <div className="users-stat-content">
                      <h3 className="users-stat-number">{noOfUser}</h3>
                      <p className="users-stat-label">Total Users</p>
                    </div>
                  </div>
                  <div className="users-stat-card">
                    <div className="users-stat-icon verified-users">
                      <i className="fas fa-user-check"></i>
                    </div>
                    <div className="users-stat-content">
                      <h3 className="users-stat-number">
                        {data.filter((user) => user?.emailVerified).length}
                      </h3>
                      <p className="users-stat-label">Verified Users</p>
                    </div>
                  </div>
                  <div className="users-stat-card">
                    <div className="users-stat-icon active-users">
                      <i className="fas fa-chart-line"></i>
                    </div>
                    <div className="users-stat-content">
                      <h3 className="users-stat-number">
                        {
                          data.filter(
                            (user) =>
                              user?.subscription &&
                              user.subscription.length > 0 &&
                              new Date(user.subscription[0]?.nextPayment) >
                                new Date(),
                          ).length
                        }
                      </h3>
                      <p className="users-stat-label">Active Subscriptions</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table Section */}
              <Table
                data={data}
                setPage={setPage}
                page={page}
                noOfUser={noOfUser}
                limit={limit}
                deleteUser={deleteUser}
                adminType={adminType}
                handleShowEdit={handleShowEdit}
                handleShowSubscribeModal={handleShowSubscribeModal}
                grantGodzillaAccess={grantGodzillaAccess}
                removeGodzillaAccess={removeGodzillaAccess}
              />
            </div>
          </div>
        </div>

        <Modal
          show={showEdit}
          size="lg"
          onHide={handleCloseEdit}
          centered
          className=""
        >
          <Modal.Body>
            <div className="otpModalMain">
              <div className="closeIcon" onClick={handleCloseEdit}>
                <i className="fa-solid fa-xmark" />
              </div>
              <EditUserData
                getUsers={getUsers}
                setShow={setShowEdit}
                selectedData={selectedData}
              />
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={showSubscribeModal}
          onHide={handleCloseSubscribeModal}
          centered
          className="users-subscribe-modal"
        >
          <Modal.Header closeButton className="users-subscribe-modal-header">
            <div className="users-subscribe-modal-title-wrap">
              <span className="users-subscribe-badge">Subscription</span>
              <Modal.Title className="users-subscribe-modal-title">
                Upgrade to Paid Plan
              </Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body className="users-subscribe-modal-body">
            <p className="users-subscribe-modal-subtitle">
              Confirm why this user is being moved to a paid subscription.
            </p>
            <div className="users-subscribe-user-chip">
              <i className="fas fa-user-circle"></i>
              <div>
                <span>{selectedUserForSubscribe?.name || "Selected User"}</span>
                <small>{selectedUserForSubscribe?.email || "No email found"}</small>
              </div>
            </div>

            <label className="users-subscribe-label" htmlFor="subscribeReason">
              Reason
            </label>
            <textarea
              id="subscribeReason"
              className="users-subscribe-textarea"
              rows={5}
              maxLength={300}
              placeholder="Example: Granting premium access after enterprise approval."
              value={subscribeReason}
              onChange={(e) => setSubscribeReason(e.target.value)}
            />
            <div className="users-subscribe-meta">
              {!subscribeReason.trim() ? (
                <small className="users-subscribe-error">Reason is required.</small>
              ) : (
                <small className="users-subscribe-hint">
                  This note will be kept for audit tracking.
                </small>
              )}
              <small className="users-subscribe-counter">
                {subscribeReason.length}/300
              </small>
            </div>
            <div className="users-subscribe-disclaimer">
              <i className="fas fa-shield-alt"></i>
              This action updates premium access immediately after confirmation.
            </div>
          </Modal.Body>
          <Modal.Footer className="users-subscribe-modal-footer">
            <button
              className="users-subscribe-cancel-btn"
              onClick={handleCloseSubscribeModal}
            >
              Cancel
            </button>
            <button
              className="users-subscribe-submit-btn"
              onClick={makeSubscribeUser}
            >
              Make Subscribe
            </button>
          </Modal.Footer>
        </Modal>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}

      {/* Styles */}
      <style jsx>{``}</style>
    </>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noOfUser,
  limit,
  deleteUser,
  adminType,
  handleShowEdit,
  handleShowSubscribeModal,
  grantGodzillaAccess,
  removeGodzillaAccess,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const checkSubscription = (nextPayment) => {
    let currentDate = new Date();
    let endDate = new Date(nextPayment);

    if (currentDate < endDate) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Joined At
                  </th>
                  <th scope="col" className="">
                    Name
                  </th>
                  <th scope="col" className="">
                    Email
                  </th>
                  <th scope="col" className="">
                    Phone
                  </th>
                  <th scope="col" className="">
                    Wallet
                  </th>
                  <th scope="col" className="">
                    country
                  </th>
                  <th scope="col" className="">
                    DOB
                  </th>
                  <th scope="col" className="">
                    Gender
                  </th>
                  <th scope="col" className="">
                    <div className="w-max-c">Email verified</div>
                  </th>
                  <th scope="col" className="">
                    Godzilla Access
                  </th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.name}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.email}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.phone ? item?.phone : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.wallet ? item?.wallet : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.country ? item?.country : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.dob}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.gender}
                      </span>
                    </td>
                    <td>
                      {item?.emailVerified ? (
                        <span className="badge bg-success w-max-c db">
                          verified
                        </span>
                      ) : (
                        <span className="badge bg-danger w-max-c db">
                          not verified
                        </span>
                      )}
                    </td>
                    <td>
                      {item?.isWeexQualify || item?.isMexcQualify ? (
                        <button
                          className="makeSubBtn me-2 "
                          onClick={() => removeGodzillaAccess(item?._id)}
                        >
                          Cancel Access
                        </button>
                      ) : (
                        <button
                          className="makeSubBtn me-2"
                          style={{
                            background: "green",
                            color: "#fff",
                          }}
                          onClick={() => grantGodzillaAccess(item?._id)}
                        >
                          Grant Access
                        </button>
                      )}
                    </td>
                    <td>
                      <div className="d-flex ai-center">
                        {adminType == "mackAdmin777" &&
                          (item?.subscription &&
                          item?.subscription.length > 0 ? (
                            <>
                              {checkSubscription(
                                item?.subscription[0]?.nextPayment,
                              ) ? (
                                <button
                                  className="makeSubBtn me-2"
                                  style={{
                                    background: "green",
                                    color: "#fff",
                                    width: 103.6,
                                  }}
                                >
                                  Subscribed
                                </button>
                              ) : (
                                <>
                                  <button
                                    className="makeSubBtn me-2 "
                                    style={{
                                      background: "red",
                                      color: "#fff",
                                      width: 103.6,
                                    }}
                                  >
                                    Expired
                                  </button>
                                  <button
                                    className="makeSubBtn me-2"
                                    onClick={() =>
                                      handleShowSubscribeModal(item)
                                    }
                                  >
                                    Make Subscribe
                                  </button>
                                </>
                              )}
                            </>
                          ) : (
                            <button
                              className="makeSubBtn me-2"
                              onClick={() => handleShowSubscribeModal(item)}
                            >
                              Make Subscribe
                            </button>
                          ))}
                        {adminType == "mackAdmin777" && (
                          <a
                            href="#"
                            className="me-2 w-30"
                            onClick={() => handleShowEdit(item)}
                          >
                            <img src={edit} alt="edit" />
                          </a>
                        )}
                        <a
                          href="#"
                          className=" w-30"
                          onClick={() => deleteUser(item?._id)}
                        >
                          <img src={Delete} alt="Delete" />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center mt-4">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfUser / limit)}
                page={page}
                onChange={handleChange}
                color="primary"
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
